import React, { useEffect, useState } from "react";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import { Alert } from "antd";
const CustomTimePicker = ({ value, onChange }) => {
  const [selectedTime, setSelectedTime] = useState("");
  const [clockValue, setClockValue] = useState(dayjs().hour(9).minute(0));

  useEffect(() => {
    if (value && dayjs(value).isValid()) {
      const rounded = dayjs(value).minute(0).second(0);
      setSelectedTime(rounded.format("h:mm A"));
      setClockValue(rounded);
    } else {
      const now = dayjs().minute(0).second(0);
      setSelectedTime(now.format("h:mm A"));
      setClockValue(now);
    }
  }, [value]);

  const handleChange = (newValue) => {
    const rounded = dayjs(newValue).minute(0).second(0);
    onChange(rounded);
    setSelectedTime(rounded.format("h:mm A"));
    setClockValue(rounded);
  };

  return (
    <ThemeProvider theme={customTheme}>
      <div className="border p-3 rounded bg-white">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StaticTimePicker
            displayStaticWrapperAs="desktop"
            value={clockValue}
            onChange={handleChange}
            slots={{ actionBar: () => null }}
            views={["hours"]}
            ampm={true}
            ampmInClock={true}
          />
        </LocalizationProvider>
        {selectedTime && (
          <Alert
            type="info"
            message={`Selected time: ${selectedTime}`}
            className="mt-3 mb-0"
          />
        )}
      </div>
    </ThemeProvider>
  );
};
export default CustomTimePicker
export const customTheme = createTheme({
  palette: {
    primary: {
      main: "#10477fe3",
    },
  },
});